import { Component, Input } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddMemberComponent } from '../add-member/add-member.component';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { NotificationService } from '../shared/services/notifications.service';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { Roles } from '../../models/commonmodel';
import { InitialsPipe } from '../shared/pipes/intials.pipe';
import { ConfirmationmodalComponent } from '../shared/components/confirmationmodal/confirmationmodal.component';
@Component({
  selector: 'app-agent-card',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, InitialsPipe],
  templateUrl: './agent-card.component.html',
  styleUrl: './agent-card.component.scss',
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',
        opacity: 1,
      })),
      transition('collapsed <=> expanded', animate('200ms ease-in-out')),
    ])
  ]
})
export class AgentCardComponent {
  @Input() agent: any; // This is the input you mentioned
  @Input() actionHidden: boolean = false;
  @Input() role: any;

  isExpanded: boolean = true;
  avatarLoadError: boolean = false;
  userAccess = this.memberService.getUserAccess();
  enumRole = Roles;

  constructor(private dialog: MatDialog, private restService: MemberInsurerRestService, private notificationService: NotificationService,
    private memberService: MemberInsurerServiceService
  ) { }

  ngOnInit(): void {
    // You might want to do initial data processing here if needed
    console.log("the role is" + this.role)
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  getInitials(): string {
    if (this.agent && this.agent.firstName && this.agent.lastName) {
      return (this.agent.firstName.charAt(0) + this.agent.lastName.charAt(0)).toUpperCase();
    }
    return 'NA'; // Or any other placeholder
  }

  // A simple deterministic color generator based on initials or name
  getInitialsColor(): string {
    if (!this.agent || (!this.agent.firstName && !this.agent.lastName)) {
      return '#CCCCCC'; // Default grey
    }
    const name = `${this.agent.firstName || ''}${this.agent.lastName || ''}`;
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
  }

  onStatusUpdate(status: boolean): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '350px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;

    const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
    dialogRef.componentInstance.title = 'Confirm';
    dialogRef.componentInstance.mode = 'Add';
    dialogRef.componentInstance.message = 'Are you sure you want to update the status?';

    dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.restService.updateAgentStatus(this.agent.userId, status).subscribe({
          next: (response: string) => {
            this.notificationService.showNotification('Status updated sucessfully');
            this.memberService.setrefreshAgents();
          },
          error: (error) => {
            const message = error?.error?.message || 'An error occurred during status update.';
            this.notificationService.showNotification(message, 'error');
          }
        });
      }
    }
    )
  }


  copiedEmail: string | null = null;
  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    this.copiedEmail = value;
    setTimeout(() => {
      this.copiedEmail = null;
    }, 1200);
  }



  onEditAgent() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '750px';
    dialogConfig.height = '550px';
    dialogConfig.data = this.agent;
    console.log("the agent data is" + this.agent)
    this.dialog.open(AddMemberComponent, dialogConfig)
  }
}
